import { getAPIURL, getBaseURL } from '../../GlobalComponents/URLs'
import { COLORS } from '../../consts'
import {
    PayloadOrderDetailViewRow,
    PayloadOrderHeader,
    PayloadOrderHeaderViewRow,
    UploadAttachmentPayload,
    decrementSaveBlockingProcessPendingCount,
    incrementSaveBlockingProcessPendingCount,
} from './orderSlice'
import { v4 as uuidv4 } from 'uuid'
import { getCurrentUser } from '../../utils'
import React from 'react'
import { isWebUser } from '../meta/metaAPI'
import { fetchVendorData } from '../inventory/inventoryAPI'
import { useAppDispatch } from '../../app/hooks'
// import { DateToString } from '../customer/customerSlice'

let initController = new AbortController()
export const cancelSearch = () => initController.abort()
export const fetchInitOrder = async (): Promise<any> => {
    let url = getAPIURL() + 'order/init'
    initController = new AbortController()
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        signal: initController.signal,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            isQuote: true,
            isCommission: false,
        }),
    })
    let json: PayloadOrderHeader = await req.json()

    json.OrderHeaderView[0].OrderDetailView = [
        // todo fix typing so only temp - lineItemNumber are required
        {
            temp: true,
            rowId: uuidv4(),
            LineItemNumber: '001',
            Available: 1,
            OrderAssemblyDetailView: [],
            OrderNumber: json.OrderHeaderView[0].OrderDetailView[0].OrderNumber,
            QuotedDeliveryOverride: '',
            QuotedDeliveryUOM: '',
            OrderEntryDate: new Date().toISOString(),
            includeDataSheets: false,
        },
    ]
    // Mark it as made in fast quote
    json.OrderHeaderView[0].OrderEntryType = 'FQ'
    return json.OrderHeaderView
}
export interface GetOrderParams {
    OrderNumber: string
    IncludeMiscInfo: boolean
    CalculateFreight: boolean
    CalculateTax: boolean
    IsWebUser?: boolean
    IsPreview?: boolean
}

export interface GetOrderReturnPayload {
    OrderHeaderView: Array<PayloadOrderHeaderViewRow & OrderMiscInfoReturnPayload>
    IsWebUser?: boolean
    IsPreview?: boolean
}
let getOrderController = new AbortController()
// export const cancelSearch = () => initController.abort()
export const fetchOrder = async (params: GetOrderParams): Promise<GetOrderReturnPayload> => {
    let url = getAPIURL() + 'order/getOrder'
    initController = new AbortController()
    let resp = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        signal: getOrderController.signal,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    if (resp.ok) {
        let json: GetOrderReturnPayload = await resp.json()
        if (json.OrderHeaderView[0].CustomerAccountCode.trim() === '')
            throw new Error('Failed to load order.')

        return { ...json, IsWebUser: params.IsWebUser, IsPreview: params.IsPreview }
    } else {
        if (isWebUser()) {
            window.location.href = `/logon.aspx?redirect=${encodeURIComponent(
                window.location.href
            )}`
        } else
            window.location.href = `${getBaseURL()}masterclient/main.aspx?redirect=${encodeURIComponent(
                getBaseURL()
            )}${window.location.pathname}`

        let responseText = await resp.text()
        throw new Error(`Failed to get order - ${responseText}`)

        //else {
        // let search = window.location.search
        // let params = new URLSearchParams(search.toLowerCase())
        // let orderNumber = params.get('ordernumber')
        // // if not logged in (web or internal) redirect to login
        // if (orderNumber && !window.location.href.includes('localhost')) {
        //     if (isWebUser()) {
        //         let redirectURL = window.location.href
        //         let paramConnector = redirectURL.indexOf('?') > -1 ? '&' : '?'
        //         redirectURL += `${paramConnector}C=${json.OrderHeaderView[0].CustomerAccountCode.trim()}`
        //         window.location.href = `/logon.aspx?redirect=${encodeURIComponent(redirectURL)}`
        //     } else
        //         window.location.href = `${getBaseURL()}masterclient/main.aspx?redirect=${encodeURIComponent(
        //             getBaseURL()
        //         )}${window.location.pathname}`
        // }
        //}
    }
}

interface FetchSendQuoteParams {
    Username: string
    Email: string
    paramsString: string
}
export const fetchSendQuote = async (params: FetchSendQuoteParams) => {
    let url = getAPIURL() + 'master/batchqueue/submit'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            ProgDomain: 'OrderProcessing',
            ProgName: 'MasterBatch',
            Params: params.paramsString,
            Username: params.Username,
            Email: params.Email,
            Crystal: true,
        }),
    })
    return req.ok
}

interface FetchDownloadPDFParams {
    OrderNumber: string
    ContactName: string
    DisplayWarehouse?: string
    IncludeImages: boolean
    OrderDate?: string
}
export const fetchDownloadPDF = async (params: FetchDownloadPDFParams) => {
    let url = getAPIURL() + 'order/GetQuoteFile'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            orderNumber: params.OrderNumber, // '2292641'
            contactName: params.ContactName, // 'test test'
            displayAddress: 'S',
            displayWarehouse: params.DisplayWarehouse, // '31'
            debug: true,
            aro: 'ARO',
            attachPDF: true,
            attachExcel: false,
            attachWord: false,
            includeImages: params.IncludeImages, // true
            supressPartNumbers: false,
        }),
    })
    if (req.ok) {
        const blob = await req.blob()
        const newBlob = new Blob([blob])

        const blobUrl = window.URL.createObjectURL(newBlob)

        const link = document.createElement('a')
        link.href = blobUrl
        link.setAttribute(
            'download',
            `AWC QUOTE ${params.OrderNumber} Dated ${params.OrderDate}.pdf`
        )
        document.body.appendChild(link)
        link.click()
        link.parentNode?.removeChild(link)

        // clean up Url
        window.URL.revokeObjectURL(blobUrl)
    }
    return req.ok
}
interface FetchRequestQuoteChangesParams {
    OrderNumber: string
    NeedDate: Date
    QuoteExpirationDate: Date
    Comments: string
}

export const fetchRequestQuoteChanges = async (params: FetchRequestQuoteChangesParams) => {
    let url = getAPIURL() + 'order/requestQuoteChanges'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            orderNumber: params.OrderNumber,
            needDate: params.NeedDate,
            quoteExpirationDate: params.QuoteExpirationDate,
            comments: params.Comments,
        }),
    })
    return req.ok
}
export interface PartsAvailability {
    Partkey: number
    NeedDate?: Date
    OrderNumber?: string
    LineNumber?: string
    Location?: string
    Quantity?: number
}

export interface PartsAvailabilityReturnPayload {
    EarliestDeliveryDate: Date
    LeadTime: number
    TotalAvailable: number
    LocationAvailability: Array<any>
}

export const fetchPartsAvailability = async (
    payload: PartsAvailability
): Promise<PartsAvailabilityReturnPayload> => {
    let url = getAPIURL() + 'availability/part'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })

    let json: PartsAvailabilityReturnPayload = await req.json()

    return json
}

export interface FetchVendorNameParams {
    PartNumber?: string
    Partkey: number
}
export interface FetchVendorNamesReturnPayload {
    VENDID: string
    NAME: string
    VendorIDName: string
}
export interface FetchVendorNameReturnPayload {
    VendorID: string
    VendorName: string
}

export const fetchVendorName = async (
    payload: FetchVendorNameParams
): Promise<FetchVendorNameReturnPayload | undefined> => {
    // TODO get prod/dev/nettest2 working
    let vendor: FetchVendorNameReturnPayload | undefined
    if (payload.PartNumber) {
        const vendorNames = await fetchVendorData()
        vendor = vendorNames.find((v) => v.VendorID === payload.PartNumber!.substring(0, 2))
    } else {
        let url = `${getAPIURL()}inventory/parts/${payload.Partkey}/vendor`

        let req = await fetch(url, {
            credentials: 'include',
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        })
        vendor = await req.json()
    }

    return vendor
}

export interface EstimatedDeliveryParams {
    OrderHeader: OrderHeaderViewRow
    OrderDetail: OrderDetailViewRow
}
export interface GetEstimatedDeliveryDateParams {
    OrderHeaderView: Array<
        GetEstimatedDeliveryDateHeaderParams & {
            OrderDetailView: Array<
                GetEstimatedDeliveryDateDetailParams & {
                    OrderAssemblyDetailView: Array<
                        GetEstimatedDeliveryDateDetailParams & { AssemblyLineItemNumber: string }
                    >
                }
            >
        }
    >
}

interface GetEstimatedDeliveryDateHeaderParams {
    OrderNumber: string
    Location: string
    Restrictions: string
    ShipmentMethodDescription: string
    ShipToState: string
    AllocationWarehouse: string
}
interface GetEstimatedDeliveryDateDetailParams {
    OrderNumber: string
    LineItemNumber: string
    PartKey: number
    OrderQuantity: number
    PartNumber: string
}

export interface EstimatedDeliveryReturnPayload {
    EstimatedDeliveryDate: string
    EstimatedDeliveryDateDescription: string
    ExpectedOnDockDate: string
    AvailableEstimatedDeliveryDate: string
    TotalAvailable: number
}

export const makeEstimatedDeliveryParams = (
    orderHeaderRow: PayloadOrderHeaderViewRow,
    orderDetailRow: PayloadOrderDetailViewRow
): GetEstimatedDeliveryDateParams => {
    return {
        OrderHeaderView: [
            {
                OrderNumber: orderHeaderRow.OrderNumber!,
                Location: orderHeaderRow.Location!,
                Restrictions: orderHeaderRow.Restrictions!,
                ShipmentMethodDescription: orderHeaderRow.ShipmentMethodDescription!,
                ShipToState: orderHeaderRow.ShipToState!,
                AllocationWarehouse: orderHeaderRow.AllocationWarehouse!,
                OrderDetailView: [
                    {
                        OrderNumber: orderDetailRow.OrderNumber,
                        LineItemNumber: orderDetailRow.LineItemNumber,
                        PartKey: orderDetailRow.PartKey as number,
                        OrderQuantity: (orderDetailRow!.OrderQuantity! as number) || 1,
                        PartNumber: orderDetailRow.PartNumber!,
                        OrderAssemblyDetailView: [],
                    },
                ],
            },
        ],
    }
}
export const fetchEstimatedDelivery = async (
    OrderHeader: PayloadOrderHeaderViewRow,
    OrderDetail: PayloadOrderDetailViewRow
): Promise<EstimatedDeliveryReturnPayload> => {
    let params = makeEstimatedDeliveryParams(OrderHeader, OrderDetail)
    let url = `${getAPIURL()}order/GetEstimatedDeliveryDate`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: EstimatedDeliveryReturnPayload = await req.json()
    return json
}

export interface LeadTimeHistoryParams {
    Partkey: number
    Period: 90 | 180
}

export interface LeadTimeHistoryReturnPayload {
    AverageLeadTime: number
    HistoryTable: Array<{
        ReceivedByLocation: number
        PurchaseOrderNumber: string
        ReceiptTimeStamp: string
        SplitCounter: number
        LineItem: string
        QuantityReceived: number
        UnitCost: number
        OrderEntryDate: string
        Trans_Time: number
        LeadTime: number
    }>
}

export const fetchLeadTimeHistory = async (
    payload: LeadTimeHistoryParams
): Promise<LeadTimeHistoryReturnPayload> => {
    let url = getAPIURL() + 'purchasing/GetAverageLeadTime'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    let json: LeadTimeHistoryReturnPayload = await req.json()
    return json
}
export interface FetchPartsPayload {
    searchValue: string
    accountCode: string
}
export interface PartSearchInfo {
    __type: string
    Markup: string
    Name: string
    Value: string
    Source: string
    Level: number
    Visible: boolean
    Key: number
}
export interface FetchPartsReturnPayload {
    d: Array<PartSearchInfo>
}

// const mockParts = {
//     d: [
//         {
//             __type: 'InventorySearchAutoCompleteEntry',
//             Name: '<div>Siemens - 6ES72141BG400XB0</div>\r\n                      <div>Simatic S7-1200, CPU 1214C, AC/DC/Relay, 120-240 VAC Supply, (14) 24 VDC DI, (10) Relay DO, (2) 0-10</div>',
//             Value: '/product/siemens-6es72141bg400xb0-cpu/1479007',
//             Source: 'Products',
//             Level: 1000,
//             Visible: true,
//             Key: 1479007,
//         },
//         {
//             __type: 'InventorySearchAutoCompleteEntry',
//             Name: '<div>Siemens - 6ES72141AG400XB0</div>\r\n                      <div>Simatic S7-1200, CPU 1214C, DC/DC/DC, 24 VDC Supply, (14) 24 VDC DI, (10) 24 VDC DO, (2) 0-10 VDC AI</div>',
//             Value: '/product/siemens-6es72141ag400xb0-cpu/1479165',
//             Source: 'Products',
//             Level: 1000,
//             Visible: true,
//             Key: 1479165,
//         },
//     ],
// }
export const fetchParts = async (
    payload: FetchPartsPayload,
    controller: AbortController
): Promise<FetchPartsReturnPayload> => {
    // return mockParts
    let currentUser = await getCurrentUser()
    // TODO get prod/dev/nettest2 working
    let sendingPayload = {
        fpCoRoot: currentUser.CompanyCode,
        fpValue: payload.searchValue,
        fpVendorID: 'All',
        fpWebAccountCode: payload.accountCode,
        fpIsLoggedIn: true,
        fpIsExternal: false,
        fpIncludeWP: false,
        fpIncludeCategories: false,
        fpInventoryReturnCount: 4, // Hardcoded 4
    }
    let url = getBaseURL() + 'website/InventorySearchAutoComplete.asmx/GetInfo'
    let req = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Request-Headers': 'Origin, X-Requested-With, Accept',
        },
        referrerPolicy: 'origin',
        body: JSON.stringify(sendingPayload),
        signal: controller.signal,
    })
        .then((resp) => {
            if (resp.ok) {
                return resp.json()
            } else throw new Error(`Bad request - ${resp.statusText}`)
        })
        .catch((err) => {
            if (err.name !== 'AbortError') console.error(`Error fetching - ${err.message}`)
        })
    let json: FetchPartsReturnPayload = await req

    return json
}

export interface FetchPriceParams {
    Partkey: number
    Price?: number
    CustomerAccountCode: string // (string, optional),
    PricingDate: string // (string, optional),
    Quantity: number //(number, optional),
    Location: string //(string, optional),
    GetPriceAndRebate: true // (boolean, optional),
    LockInCost: number //(number, optional),
    UseLastCost: boolean //(boolean, optional),
    OrderFromCode: string //(string, optional)
}

export interface FetchPriceReturnPayload {
    CustomerPrice: number //(number, optional),
    CustomerRebate: number //(number, optional),
    List: number //(number, optional),
    Cost: number //(number, optional),
    Other: number //(number, optional),
    Tariff: number //(number, optional),
    CustomerContractType: string
    CustomerContractBasis: string
    CustomerContractExpiration: string
    DiscountPercent: number //(number, optional),
    POCostMessage: string //(string, optional),
    VendorContractNumber: string //(string, optional),
    CustomerContractNumber: string //(string, optional),
    SPANumberOnPO: boolean // (boolean, optional),
    MfgRebateCode: string //(string, optional),
    OrderFromCode: string //(string, optional)
    MaterialsManager: string
    PricingUpdateMethod: string
    PricingEffectiveDate: string
    RebatedCost: number
}
export const fetchPriceInfo = async (
    payload: FetchPriceParams
): Promise<FetchPriceReturnPayload> => {
    let url = getAPIURL() + 'pricing/price'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    let json: FetchPriceReturnPayload = await req.json()

    return json
}

export interface FetchRebateStatusParams {
    Partkey: number
    CustomerAccountCode: string
    UnitPrice: number
    UnitCost: number
}

export interface RebateHeaderCustView {
    RebateKey: number
    VendID: string
    MfgRebateCode: string
    EffectiveDate: string // date
    ExpirationDate: string // date
    CustomerAccountCode: string
    MfgCustomerAccountCode: string
    BillToName: string
    PricingDate: string // date
}
export interface FetchRebateStatusReturnPayload {
    RebateStatus: string
    RebateAmount: number
    MfgRebateCode: string
    RebateTypeDescription: string
    EffectiveDate: string // date
    ExpirationDate: string // date
    RebateKey: number
    SimilarOnRebate: boolean
    RebateHeaderCustomerView?: RebateHeaderCustView[]
}

export const fetchRebateStatus = async (
    payload: FetchRebateStatusParams
): Promise<FetchRebateStatusReturnPayload> => {
    let url = getAPIURL() + 'contract/GetRebateStatus'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    let json: FetchRebateStatusReturnPayload = await req.json()

    return json
}

// const _fetch = <S, T>(url: string): ((params: S) => Promise<T | string>) => {
//     return async (params: S) => {
//         let req = await fetch(url, {
//             credentials: 'include',
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(params),
//         })
//         if (req.ok) {
//             return req.json()
//         } else {
//             return req.text()
//         }
//     }
// }
interface FetchDataSheetsParams {
    PartKey: number
}
export type FetchDataSheetsReturn = string[]

export const fetchDataSheets = async (
    params: FetchDataSheetsParams
): Promise<FetchDataSheetsReturn | string> => {
    const dataSheetUrl = getAPIURL() + 'inventory/parts/datasheets/' + params.PartKey

    let req = await fetch(dataSheetUrl, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
    })
    if (req.ok) {
        return req.json()
    } else {
        return req.text()
    }
}
// const useAPI = <S, T>(url: string, params: S): [T | null, boolean, string] => {
//     const [result, setResult] = React.useState<T | null>(null)
//     const [loading, setLoading] = React.useState(true)
//     const [error, setError] = React.useState('')
//     const pastParams = React.useRef<S | null>(null)
//     const pastUrl = React.useRef('')
//     // const currentReq = React.useRef
//     React.useEffect(() => {
//         if (
//             JSON.stringify(params) === JSON.stringify(pastParams.current) &&
//             JSON.stringify(url) === JSON.stringify(pastUrl.current)
//         ) {
//             return
//         }
//         pastParams.current = params
//         pastUrl.current = url
//         const _fetch = async () => {
//             setLoading(true)
//             let req = await fetch(url, {
//                 credentials: 'include',
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(params),
//             })
//             if (req.ok) {
//                 let json = await req.json()
//                 setResult(json)
//                 setError('')
//             } else {
//                 let text = await req.text()
//                 setError(text)
//             }
//             setLoading(false)
//         }
//         _fetch()
//     }, [url, params])

//     return [result, loading, error]
// }

let caches: Record<string, Record<string, any>> = {}
const useCachedAPI = <S, T>(
    url: string,
    params: S,
    cacheName: string,
    partKey?: number | null,
    makeCacheKey?: (params: S) => string,
    // to avoid calling with partial payloads
    validPayload?: (params: S) => boolean,
    row?: PayloadOrderDetailViewRow
): [T | null, boolean, string] => {
    const dispatch = useAppDispatch()
    const [result, setResult] = React.useState<T | null>(null)
    const [loading, setLoading] = React.useState(true)
    const [error, setError] = React.useState('')
    const pastParams = React.useRef<S | null>(null)
    const pastUrl = React.useRef('')
    if (!caches[cacheName]) {
        caches[cacheName] = {}
    }

    // const currentReq = React.useRef
    React.useEffect(() => {
        if (
            JSON.stringify(params) === JSON.stringify(pastParams.current) &&
            JSON.stringify(url) === JSON.stringify(pastUrl.current)
        ) {
            return
        }
        pastParams.current = params
        pastUrl.current = url
        const _fetch = async () => {
            if (validPayload && !validPayload(params)) {
                return
            }
            if (cacheName === 'estimatedDelivery' && partKey === 0) {
                return
            }
            if (row && row.temp) {
                return
            }

            setLoading(true)

            let cache = caches[cacheName]
            let cacheKey = makeCacheKey ? makeCacheKey(params) : JSON.stringify(params)
            if (cache[cacheKey]) {
                setLoading(false)
                setResult(cache[cacheKey])
                setError('')
                return
            }
            let reqProm = fetch(url, {
                credentials: 'include',
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(params),
            })
            let req = await reqProm
            if (req.ok) {
                dispatch(incrementSaveBlockingProcessPendingCount())
                let json = await req.json()
                cache[cacheKey] = json
                setResult(json)
                dispatch(decrementSaveBlockingProcessPendingCount())
                setError('')
            } else {
                let text = await req.text()
                setError(text)
            }
            setLoading(false)
        }
        _fetch()
    }, [url, params])

    return [result, loading, error]
}

// let caches = {}
// const useCache = (cacheName: string, api: typeof useAPI) => {
//     return () => {}
// }

const priceStatisticsURL = getAPIURL() + 'pricing/priceStatistics'
export const usePricingStatistics = (params: FetchPricingStatisticsParams) =>
    useCachedAPI<FetchPricingStatisticsParams, FetchPricingStatisticsReturnPayload>(
        priceStatisticsURL,
        params,
        'estimatedDelivery',
        params.Partkey,
        (params: FetchPricingStatisticsParams) => {
            return `c${params.CustomerAccountCode}k${params.Partkey}`
        },
        (params: FetchPricingStatisticsParams) => {
            return !!params.CustomerAccountCode && !!params.Partkey
        }
    )

const estimatedDeliveryURL = `${getAPIURL()}order/GetEstimatedDeliveryDate`
export const useEstimatedDelivery = (
    params: GetEstimatedDeliveryDateParams,
    row: PayloadOrderDetailViewRow
) => {
    return useCachedAPI<GetEstimatedDeliveryDateParams, EstimatedDeliveryReturnPayload>(
        estimatedDeliveryURL,
        params,
        'estimatedDelivery',
        params.OrderHeaderView[0].OrderDetailView[0].PartKey,
        (params: GetEstimatedDeliveryDateParams) => {
            let header = params.OrderHeaderView[0]
            let line = params.OrderHeaderView[0].OrderDetailView[0]
            return `l${header.Location}k${line.PartKey}q${line.OrderQuantity}`
        },
        (params: GetEstimatedDeliveryDateParams) => {
            return true
        },
        row
    )
}

export interface FetchRebateAnalyticsParams {
    Partkey: number
    CustomerAccountCode: string
    Warehouse: string
}

// type rebateAnalyticsCache = Record<>

export interface FetchRebateAnalyticsReturnPayload {
    QuantityOfRebates: number
    RebateMin: number
    RebateMax: number
    RebateAvg: number
    RebateAnalyticRows: Array<{
        CustomerAccountCode: string
        CustomerName: string
        CustomerType: string
        MfgRebateCode: string
        RebateAmount: number
        RebateCost: number
        RebateListPercentage: string
    }>
}
export const SEARCHING = 'SEARCHING'
let analyticsCache: Record<string, FetchRebateAnalyticsReturnPayload | typeof SEARCHING> = {}
export const makeAnalyticsKey = (params: FetchRebateAnalyticsParams) => {
    return `pk${params.Partkey}ca${params.CustomerAccountCode}${params.Warehouse}`
}
export const FetchRebateAnalytics = async (
    payload: FetchRebateAnalyticsParams
): Promise<FetchRebateAnalyticsReturnPayload | typeof SEARCHING> => {
    let cacheKey = makeAnalyticsKey(payload)
    let cachedValue = analyticsCache[cacheKey]
    if (cachedValue) {
        return cachedValue
    }
    let url = getAPIURL() + 'contract/GetRebateAnalytics'
    analyticsCache[cacheKey] = SEARCHING

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    let json: FetchRebateAnalyticsReturnPayload = await req.json()
    analyticsCache[cacheKey] = json
    return json
}

export interface FetchPricingStatisticsParams {
    Partkey: number
    CustomerAccountCode: string
}

export interface FetchPricingStatisticsReturnPayload {
    List: number
    PricingEffectiveDate: string
    AverageSellPrice: number
    CustomerType: string
    SalesHistory: Array<{
        TransactionDate: string
        CustomerName: string
        UnitRebate: number
        UnitPrice: number
        GrossProfit: number
        Discount: number
        CustomerAccountCode: string
    }>
}
// let pricingStatistictsCache: Record<string, FetchPricingStatisticsReturnPayload | typeof SEARCHING> = {}
// export const makepricingStatisticsKey = (params: FetchPricingStatisticsParams) => {
//     return `pk${params.Partkey}ca${params.CustomerAccountCode}${params.Warehouse}`
// }
// export const fetchPricingStatisticts = async (
//     payload: FetchPricingStatisticsParams
// ): Promise<FetchPricingStatisticsReturnPayload | typeof SEARCHING> => {
//     let cacheKey = makepricingStatisticsKey(payload)
//     let cachedValue = pricingStatistictsCache[cacheKey]
//     if (cachedValue) {
//         return cachedValue
//     }
//     let url = getAPIURL() + 'pricing/getPriceStatistics'
//     pricingStatistictsCache[cacheKey] = SEARCHING

//     let req = await fetch(url, {
//         credentials: 'include',
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//     })
//     let json: FetchPricingStatisticsReturnPayload = await req.json()
//     pricingStatistictsCache[cacheKey] = json
//     return json
// }

export const fetchPricingStatistics = async (
    payload: FetchPricingStatisticsParams
): Promise<FetchPricingStatisticsReturnPayload> => {
    let url = getAPIURL() + 'pricing/priceStatistics'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    let json: FetchPricingStatisticsReturnPayload = await req.json()

    return json
}

export interface FetchXrefInfoPayload {
    Partkey: string
    CustomerAccountCode: string
}
export type FetchXrefInfoReturnPayload = string
export const fetchXrefInfo = async (
    payload: FetchXrefInfoPayload
): Promise<FetchXrefInfoReturnPayload> => {
    let url = getAPIURL() + 'contract/xRef'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    if (req.status === 204) return ''
    let json: FetchXrefInfoReturnPayload = await req.json()

    return json
}
export interface UploadAttachmentReturnPayload {
    SystemFilename: string
    SystemFilenameExtension: string
}
export const fetchUploadAttachment = async (payload: UploadAttachmentPayload) => {
    let url = getAPIURL() + 'order/AddAttachment'
    let newPayload = {
        ...payload,
        fileData: payload.fileData.split('base64,')[1],
    }
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newPayload),
    })
    let json: UploadAttachmentReturnPayload = await req.json()

    return json
}

export interface OrderHistoryParams {
    customerAccountCode: string
    contactEmailAddress: string
}
export type OrderHistoryReturn = Array<{
    OrderDate: string
    Contact: string
    OrderType: string
    CustomerReference: string
    OrderNumber: string
    OrderEntryType: string
    EntityName: string
    ContactEmailAddress: string
    ContactEmailDomain: string
    UniqueCustomerId: number

    UniqueCustomerName: string
    VendorId: string
}>

export const fetchOrderHistory = async (params: OrderHistoryParams) => {
    let url = getAPIURL() + 'order/getCustomerOrderHistory'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    let json: OrderHistoryReturn = await req.json()

    return json
}

export const fetchDeleteAttachment = async (orderFilenameId: number): Promise<any> => {
    return new Promise((resolve) => setTimeout(() => resolve(true), 10))
}

export const fetchUpdateAttachment = async (orderFilenameId: number) => {
    return new Promise((resolve) => setTimeout(() => resolve(true), 10))
}

export interface OrderSavePayload extends PayloadOrderHeader {}

export const fetchSaveOrder = async (payload: OrderSavePayload): Promise<OrderSavePayload> => {
    let url = getAPIURL() + 'order/saveOrder'
    let resp = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        // gets called on eleaving through cog, needs to keep alive to ensure it goes through
        // keepalive: true,
    })
    return resp.json()
    // if (resp.ok) return resp.json()
    // else throw new Error('Failed to save order.')

    // return json
}
//{ OrderHeaderView: Array<{ OrderNumber: string }
interface CopyOrderParams {
    OrderNumber: string
    CustomerAccountCode: string
    ContactKey: number
    UpdatePricing: boolean
    UpdateAvailability: boolean
    SaveCopy: boolean
}
export const fetchCopyOrder = async (payload: CopyOrderParams): Promise<GetOrderReturnPayload> => {
    // return new Promise(resolve => setTimeout(() => resolve(true), 10));
    let url = getAPIURL() + 'order/CopyOrderToNewQuote'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    if (!req.ok) throw new Error('Failed to copy order.')
    let json: GetOrderReturnPayload = await req.json()
    return json

    // return json
}

export interface OrderMiscInfoPayload {
    CalculateFreight?: boolean
    CalculateTax?: boolean
    OrderHeaderView: Array<PayloadOrderHeaderViewRow>
}
export interface OrderMiscInfoReturnPayload {
    CreditStatus?: {
        Color: COLORS
        Caption: string
        SalesAction: string
        Terms: string
        IsTaxExempt: boolean
        OverLimit: boolean
        CreditLimit: number
        ARBalance: number
        BacklogBalance: number
        ARRep: {
            Username: string
            Email: string
            FullName: string
        }
    }
    OrderValue: {
        Cost: number
        Tariff: number
        SubTotal: number
        CommissionSubTotal: number
        FreightEstimate: number
        FreightErrorMessage: string
        Total: number
        TaxAmt: number
        TaxPct: number
        DesignGuideSubtotal: number
        RebateTotal: number
        ReplacementCostUsed: boolean
        ZeroCostLinesFound: boolean
        AvgTierCostUsed: boolean
        LastCostUsed: boolean
        VendorAlloc: {}
        SalesByInventoryType: {}
        CostByInventoryType: {}
        InvoicedByInventoryType: {}
    }
    Tax?: number
    SalesPersonAssignments?: Array<{
        SalesPerson: string
        SalesPersonName: string
        LineItems: Array<string>
    }>
}

let orderMiscController = new AbortController()
export const cancelOrderMisc = () => orderMiscController.abort()
export const fetchOrderMiscInfo = async (
    payload: OrderMiscInfoPayload
): Promise<OrderMiscInfoReturnPayload> => {
    // return new Promise(resolve => setTimeout(() => resolve(true), 10));
    let url = getAPIURL() + 'order/getOrderMiscInfo'
    orderMiscController = new AbortController()
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        signal: orderMiscController.signal,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    if (req.ok) {
        let json: OrderMiscInfoReturnPayload = await req.json()
        return json
    } else throw new Error('Failed to save order.')
}

export interface DownloadAttachmentPayload {
    SystemFilename: string
    FriendlyFilename: string
    SystemFilenameExtension: string
    contentType: string
}

export const getAttachmentDownloadURL = (payload: OrderFilenamesRow) => {
    let url =
        getAPIURL() +
        'order/GetAttachment' +
        `?systemfilename=${payload.SystemFilename}` +
        `&systemfilenameextension=${payload.SystemFilenameExtension}` +
        `&friendlyfilename=${payload.FriendlyFilename}` +
        `&contenttype=${payload.ContentType}`
    //https://nettest2.awc-inc.com/webapi/order/GetAttachment
    //?systemfilename=21380&systemfilenameextension=pdf
    //&friendlyfilename=.5%204000%20WITH%20VPVL051.pdf&contenttype=application%2Fpdf
    return url
}

export interface QuoteUserInfo {
    CompanyCode: string
    Username: string
    Firstname: string
    Lastname: string
    Email: string
    TelephoneNumber: string
    Warehouse: string
    Position: string
}

// export interface QuoteUserReturnPayload {
//     User: QuoteUserInfo
// }

// export interface QuoteUserInfo {
//     CompanyCode: string
//     Username: string
//     CompanyName: string
//     Firstname: string
//     Lastname: string
//     Email: string
//     Warehouse: string
//     WarehouseName: string
//     EmployeeNo: string
//     TelephoneNumber: string
//     Extension: string
//     FaxNumber: string
//     ID: number
//     EmailSurveyCC: string
//     PublishCellPhone: boolean
//     PublishHomePhone: boolean
//     isLinkedToPayroll: boolean
//     HomeWarehouse: string
//     EmailQuoteFollowUp: boolean
//     IsInactive: boolean
//     HRCompanyCode: string
//     CellPhoneCarrierID: number
//     SMSAlerts: boolean
//     CellPhoneCarrierName: string
//     RowError?: string
//     RowState?: number
//     Table?: Array<QuoteUserInfo>
//     ItemArray?: Array<any>
//     HasErrors?: boolean
// }

export const fetchQuoteUser = async (username: string): Promise<QuoteUserInfo> => {
    let url = getAPIURL() + 'User/info'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ Username: username }),
    })
    if (req.ok) {
        let json: QuoteUserInfo = await req.json()
        return json
    } else throw new Error(`Failed to get user ${username}`)
}

export interface WarehouseReturnPayload {
    locnum: string
    id: string
    name: string
    addr1: string
    addr2: string
    addr3: string
    country: string
    city: string
    state: string
    zip: string
    phone: string
    wats: string
    after_hrs: string
    fax: string
    modem: string
    telex: string
    bo_support: string
    whtype: string
    supply_by: string
    ordfrm: string
    ShipVia: string
    InboundFreightAccount: string
    GLDepositAccount: string
    InboundFreightStateDefault: boolean
    seqno: string
    ExpeditorUsername: string
    InvoiceEmail: string
    NamedCarrierServiceKey: string
    CarrierTermsKey: number
    NamedFreightCarrierServiceKey: string
    FreightTermsKey: number
    PublishLocation: boolean
    SuppressDRPXferOut: boolean
    Timezone: string
    Notes: string
    ExpeditorEmail: string
    WarehouseEmail: string
    AverageLaborRate: number
    OverheadCostRecoveryGLCode: string
    DefaultAllocationWarehouse: string
    ServiceCommissionPercent: number
    AverageOverheadCostRate: number
    LifeCycleEmail: string
    RowError?: string
    RowState?: number
    Table?: any
    ItemArray?: Array<any>
    HasErrors?: boolean
}

export const fetchWarehouse = async (warehouseNum: string): Promise<WarehouseReturnPayload> => {
    let url = getAPIURL() + `Warehouse/Location/${warehouseNum.trim()}`
    let req = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    })
    if (req.ok) {
        let json: WarehouseReturnPayload = await req.json()
        return json
    } else throw new Error(`Failed to get warehouse ${warehouseNum}`)
}

interface CarrierServices {
    ServiceName: string
    CarrierServiceValue: string
    CarrierServiceDescription: string
    CollectCapable: boolean
    TransitTime: number
    NamedCarrierServiceKey: string
    CarrierServiceKey: number
}
export interface CarrierServiceOptions {
    CarrierKey: number
    CarrierName: string
    CarrierNameABR: string
    CarrierServices: Array<CarrierServices>
}

export interface CarrierServiceOptionsReturnPayload extends Array<CarrierServiceOptions> {}

export const fetchCarrierServiceOptions = async (): Promise<CarrierServiceOptionsReturnPayload> => {
    let url = getAPIURL() + 'freight/CarrierServiceOptions'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    })
    if (req.ok) {
        let json: CarrierServiceOptionsReturnPayload = await req.json()
        return json
    } else throw new Error('Failed to get carrier service options')
}

export interface FreightTerms {
    TermsKey: number
    Terms: string
    ShortDescription: string
    Description: string
    RowError?: string
    RowState?: number
    Table?: any
    ItemArray?: Array<any>
    HasErrors?: boolean
}

export interface FreightTermsReturnPayload extends Array<FreightTerms> {}

export const fetchFreightTerms = async (): Promise<FreightTermsReturnPayload> => {
    let url = getAPIURL() + 'freight/FreightTerms'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    })
    if (req.ok) {
        let json: FreightTermsReturnPayload = await req.json()
        return json
    } else throw new Error('Failed to get freight terms')
}

interface FileImportValue<Type> {
    Value: Type
}

export interface ImportBOMFetchParams {
    OrderNumber: string
    CustomerAccountCode: string
    SellingLocation?: string
    BOMLineItems: Array<ImportBOMLI>
}

export interface ImportBOMLI {
    Row: FileImportValue<number>
    PartNumber: FileImportValue<string>
    Quantity: FileImportValue<number>
    NeedDate: FileImportValue<Date | null>
    LineItemNotes: FileImportValue<string>
}

export interface ImportBOMReturnLI {
    Row: number
    LineItem: { [index: string]: any[] } & OrderDetailViewRow & { Row: number }
    Problem?: ImportBOMReturnProblem
}

interface ImportBOMReturnProblem {
    Name: string
    FieldName: string
    Value: string | number | Date
    Message: string
    Severity: any
}

export const fetchImportBOM = async (
    params: ImportBOMFetchParams
): Promise<Array<ImportBOMReturnLI>> => {
    let url = getAPIURL() + 'order/importBOM'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    if (req.ok) {
        let json: Array<ImportBOMReturnLI> = await req.json()
        return json
    } else throw new Error('Failed to import BOM')
}

export interface CommissionOrderImport {
    VendorReference: string
    CommissionOrderItems: Array<CommissionOrderImportItem>
}

export interface CommissionOrderImportItem {
    Row: FileImportValue<number>
    OrderNumber: FileImportValue<string>
    InvoiceNumber: FileImportValue<string>
    InvoiceDate: FileImportValue<Date | null>
    CustomerAccountCode?: FileImportValue<string>
    CustomerPONumber?: FileImportValue<string>
    ShipToName?: FileImportValue<string>
    ShipToAddress1?: FileImportValue<string>
    ShipToCity?: FileImportValue<string>
    ShipToState?: FileImportValue<string>
    ShipToZipcode?: FileImportValue<string>
    PartNumber: FileImportValue<string>
    Description: FileImportValue<string>
    OrderQuantity: FileImportValue<number>
    UnitPrice: FileImportValue<number>
    ExtPrice: FileImportValue<number>
    CommissionProductCode: FileImportValue<string>
    CommissionPercentage: FileImportValue<number>
    NeedDate: FileImportValue<Date | null>
}

export interface ImportCommissionOrdersReturn {
    FirstRow: number
    Order: { [index: string]: any } & OrderHeaderViewRow & {
            Row: number
            InvoiceNumber: string
            InvoiceDate: Date
            LineItems: ImportCommissionOrdersReturnLI[]
        }
    Problems: ImportCommissionOrdersReturnProblem[]
}
export interface ImportCommissionOrdersReturnLI {
    Row: number
    LineItem: { [index: string]: any } & OrderDetailViewRow & {
            Row: number
            InvoiceNumber: string
        }
    Problems: ImportCommissionOrdersReturnProblem[]
}

export interface ImportCommissionOrdersReturnProblem {
    Name: string
    FieldName: string
    Value: string | number | Date
    Message: string
    Severity: any
}

export const fetchImportCommissionOrders = async (
    params: CommissionOrderImport
): Promise<Array<ImportCommissionOrdersReturn>> => {
    let url = getAPIURL() + 'order/importCommissionOrders'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    })
    if (req.ok) {
        let json: Array<ImportCommissionOrdersReturn> = await req.json()
        return json
    } else throw new Error('Failed to import commission orders')
}
